import { defineNuxtPlugin } from "nuxt/app";
import * as ck from "@ckweb/common";

export default defineNuxtPlugin({
  name: "ckweb:common",
  setup: (nuxtApp) => {
    nuxtApp.provide("ck", ck);

    (globalThis as any).ck = ck;
    if (import.meta.client) {
      Object.defineProperty(window, "ck", { value: ck });
    }
  },
});
